module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "show": _vm.showEditTagModal,
      "effect": "fade"
    },
    on: {
      "closeOnEscape": _vm.closeModal
    }
  }, [_c('div', {
    staticClass: "modal-header center",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_c('span', [_vm._v("×")])]), _vm._v(" "), (!_vm.selectImageMode) ? _c('h4', {
    staticClass: "modal-title center"
  }, [_vm._v("Update Tag")]) : _vm._e(), _vm._v(" "), (_vm.selectImageMode) ? _c('h4', {
    key: "selectImageMode",
    staticClass: "modal-title center"
  }, [_vm._v("Select Image")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.errorMessage.length) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-close": "alert"
    },
    on: {
      "click": function($event) {
        _vm.clearError()
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      'col-xs-4 col-xs-offset-4': !_vm.selectImageMode, 'col-xs-12': _vm.selectImageMode
    }
  }, [_c('resource-picker', {
    staticClass: "margin-top-15",
    attrs: {
      "imageButton": true,
      "imageUrl": _vm.tagToBeEdited.image_url
    },
    on: {
      "open": function($event) {
        _vm.goToPageTwo()
      },
      "close": function($event) {
        _vm.goToPageOne()
      },
      "selected": _vm.updateImage
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.selectImageMode),
      expression: "!selectImageMode"
    }],
    staticClass: "col-md-12"
  }, [_c('el-dropdown', {
    staticClass: "margin-bottom-20",
    attrs: {
      "trigger": "click",
      "size": "small",
      "show-timeout": 50,
      "hide-timeout": 50
    },
    on: {
      "command": _vm.updateTagToBeEdited
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.tagTypeLabel) + "\n\t\t\t\t\t\t\t"), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "contains"
    }
  }, [_vm._v("contains")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "may_contain"
    }
  }, [_vm._v("may contain")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label margin-top-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tagToBeEdited.name),
      expression: "tagToBeEdited.name"
    }],
    staticClass: "form-control input-sm edited",
    attrs: {
      "disabled": !_vm.$root.permissions['menu_manager tags update'],
      "type": "text",
      "id": "form_control_1"
    },
    domProps: {
      "value": (_vm.tagToBeEdited.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tagToBeEdited, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_1"
    }
  }, [_vm._v("Tag Name")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [(!_vm.selectImageMode && !_vm.$root.permissions['menu_manager tags update']) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_vm._v("\n\t\t\t\tClose\n\t\t\t")]) : _vm._e(), _vm._v(" "), (!_vm.selectImageMode && _vm.$root.permissions['menu_manager tags update']) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.updateTag()
      }
    }
  }, [_vm._v("\n\t\t\t\tSave\n\t\t\t")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5fc294db"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/MenuManager/Tags/EditTag.vue
// module id = 734
// module chunks = 0